import { type TFunction } from 'i18next';

import { OrganizationUpdateRequestDTOEmployeeCount, PlatformLocale } from '@/api/generated';

export const getNumberOfEmployeesOptions = (t: TFunction) => [
  {
    label: t('common:number.range', { min: 0, max: 20 }),
    value: OrganizationUpdateRequestDTOEmployeeCount.RANGE_0_20
  },
  {
    label: t('common:number.range', { min: 21, max: 99 }),
    value: OrganizationUpdateRequestDTOEmployeeCount.RANGE_21_99
  },
  {
    label: t('common:number.range', { min: 100, max: 299 }),
    value: OrganizationUpdateRequestDTOEmployeeCount.RANGE_100_299
  },
  {
    label: t('common:number.range', { min: 300, max: 499 }),
    value: OrganizationUpdateRequestDTOEmployeeCount.RANGE_300_499
  },
  {
    label: t('common:number.range', { min: 500, max: 999 }),
    value: OrganizationUpdateRequestDTOEmployeeCount.RANGE_500_999
  },
  {
    label: t('common:number.range', { min: 1000, max: 1999 }),
    value: OrganizationUpdateRequestDTOEmployeeCount.RANGE_1000_1999
  },
  {
    label: t('common:number.moreThan', { count: 2000 }),
    value: OrganizationUpdateRequestDTOEmployeeCount.MORE_THAN_2000
  }
];

export const getInvitationLanguageOptions = (t: TFunction) =>
  Object.keys(PlatformLocale).map(language => ({
    label: t(`common:common.languages.${language}`),
    value: language
  }));
